import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
    // "hotel" |"retail"|"restaurant"|"ecommerce"
  const [routeState, setRouteState] = useState("hotel");

  const [darkMode, setDarkMode] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem("darkMode");
    return saved ? JSON.parse(saved) : false;
  });

  const [currency, setCurrency] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem("currency");
    return saved ? JSON.parse(saved) : "$";
  });

  useEffect(() => {
    // Save preference to localStorage
    localStorage.setItem("darkMode", JSON.stringify(darkMode));

    // Apply dark class to document
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  useEffect(() => {
    // Save preference to localStorage
    localStorage.setItem("currency", JSON.stringify(currency));
  }, [currency]);

  const toggleDarkMode = () => setDarkMode((prev) => !prev);
  const toggleCurrency = (currVal) => setCurrency(currVal);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode ,currency,toggleCurrency,routeState ,setRouteState}}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
